import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type NotePresentation from '../../interfaces/simulation/notePresentation';

const url = '/api/finances/simulation/notePresentation';

export const getAllNotePresentation = async (
	params: URLSearchParams,
): Promise<TemplateRequestGet<NotePresentation>> => {
	const data = await request.get<unknown, TemplateRequestGet<NotePresentation>>(
		`${url}?${params.toString()}`,
	);

	return data;
};

export const deleteNotePresentation = (identifiantNotePresentation: number) =>
	request.delete(`${url}/${identifiantNotePresentation}`);

export const createNotePresentation = (data: any) => request.post(url, data);

export const updateNotePresentation = async (
	notePresentation: NotePresentation,
): Promise<NotePresentation> => {
	const data = await request.put<unknown, NotePresentation>(
		`${url}/${notePresentation.identifiant}`,
		notePresentation,
	);

	return data;
};

export const getNotePresentation = async (
	identifiantNotePresentation: number,
): Promise<NotePresentation> => {
	const data = await request.get<unknown, NotePresentation>(
		`${url}/${identifiantNotePresentation}`,
	);

	return data;
};

export const restoreNotePresentation = async (
	identifiantNotePresentation: number,
): Promise<NotePresentation> => {
	const data = await request.put<unknown, NotePresentation>(
		`${url}/${identifiantNotePresentation}/restore`,
	);

	return data;
};
